module.exports = __webpack_public_path__ + "img/team-member-bg.73170327.png";